import { __BEACON_INIT_KEY__ } from "../globals";

const BEACON_SLIDEOUT_TRANSITION_STYLES = {
  transition: "right 500ms ease-in-out",
};

const BEACON_RIGHT_SLIDEOUT_STYLES = {
  left: "auto !important",
  right: "calc(var(--right-slideout-width, 28rem) + 30px) !important",
};

export const BEACON_RESET_CSS = {
  ".hsds-beacon .Beacon .BeaconContainer": {
    ...BEACON_SLIDEOUT_TRANSITION_STYLES,
    bottom: "100px !important",
    right: "30px !important",
  },
  ".hsds-beacon .Beacon .BeaconFabButtonFrame": {
    ...BEACON_SLIDEOUT_TRANSITION_STYLES,
    bottom: "30px !important",
    right: "30px !important",
  },
  "body.has-right-slideout-open .hsds-beacon .Beacon .BeaconContainer":
    BEACON_RIGHT_SLIDEOUT_STYLES,
  "body.has-right-slideout-open .hsds-beacon .Beacon .BeaconFabButtonFrame":
    BEACON_RIGHT_SLIDEOUT_STYLES,
  "body.has-ramsay-chat-open .hsds-beacon .Beacon .BeaconContainer": {
    left: "auto !important",
    right: "calc(360px + 30px) !important",
  },
  "body.has-ramsay-chat-open .hsds-beacon .Beacon .BeaconFabButtonFrame": {
    left: "auto !important",
    right: "calc(360px + 30px) !important",
  },
};

export const initBeacon = () => (window as any).Beacon("init", `${__BEACON_INIT_KEY__}`);

export const configureBeacon = () => {
  const config = {
    docsEnabled: true,
    messagingEnabled: true,
    mode: "askFirst",
    messaging: {
      chatEnabled: true,
    },
    enablePreviousMessages: true,
    display: { style: "icon" },
  };
  (window as any).Beacon("config", config);
};

export const destroyBeacon = () => {
  (window as any).Beacon("destroy");
};

export const setIdentity = (self: { name?: string; email?: string; signature?: string }) => {
  (window as any).Beacon("identify", self);
};
